(function() { window.GUID_91a1d55d_9671_4025_bbf0_b7dec6189d74 = { getGuid: function() { return "91a1d55d-9671-4025-bbf0-b7dec6189d74"; } }; })();
var Schedules;
(function (Schedules) {
    var desktop;
    (function (desktop) {
        var body = $('body');
        var masterContainerOverEverything = $('#MasterContainerOverEverything');
        var btnSaveChanges = $('#BtnSaveChanges');
        var btnCancelChanges = $('#BtnCancelChanges');
        var btnFlipEncounters = $('#BtnFlipEncounters');
        var btnFlipOpponents = $('#BtnFlipOpponents');
        var btnCallMatch = $('#BtnCallMatch');
        var btnCallMatchExcel = $('#BtnCallMatchExcel');
        var btnShowCallMatchDetail = $('#BtnShowCallMatchDetail');
        var btnShowScore = $("#BtnShowScore");
        var btnShowTeamDetail = $("#BtnShowTeamDetail");
        var btnShowScanDetail = $("#BtnShowScanDetail");
        var btnSeeConflicts = $('#BtnSeeConflicts');
        var btnConflicts = $('#BtnConflicts');
        var btnCallMatchTable = $('#BtnCallMatchTable');
        var btnEraseConflicts = $('#BtnEraseConflicts');
        var btnOffsetSchedule = $('#BtnOffsetSchedule');
        var btnUnPrintSelected = $('#BtnUnPrintSelected');
        var btnForcePrintSelected = $('#BtnForcePrintSelected');
        var btnChangeMatchNumber = $('#BtnChangeMatchNumber');
        var btnRemoveCheckIn = $('#BtnRemoveCheckIn');
        var btnChangeSurface = $('#BtnChangeSurface');
        var btnShowBracket = $("#BtnShowBracket");
        var btnCallNextMatch = $("#BtnCallNextMatch");
        btnChangeSurface.off('click');
        var btnShowBrackets = $('#BtnShowBrackets');
        var btnTwinCorrector = $('#BtnTwinCorrector');
        var btnSendToOtherEvent = $('#BtnSendToOtherEvent');
        var btnAssignAndOptimizeMatches = $('#BtnAssignAndOptimizeMatches');
        let btnShowScoreKeeperInfo = $("#BtnShowScoreKeeperInfo");
        btnShowScoreKeeperInfo.off('click');
        var btnScoreSheetAdvanced = $('#BtnScoreSheetAdvanced');
        var btnRecalculateSelectedScoreSheets = $('#BtnRecalculateSelectedScoreSheets');
        var checkAllConflictClicked = true;
        desktop.selectedIds = [];
        var filteredSchedulesCount = $('#FilteredSchedulesCount');
        var warningFilterOutOfActualdate = $('#WarningFilterOutOfActualdate');
        var schedulesContainer = $('#SchedulesContainer');
        desktop.pendingChanges = $('#PendingChanges');
        var isSchedulerMode = $('#IsSchedulerMode').val() == "True";
        let gridViewSchedulesUI = $('#GridViewSchedules');
        let gridViewSchedules = gridViewSchedulesUI.data('context');
        let gridViewConflictsUI = $('#GridViewConflicts');
        let gridViewConflicts = gridViewConflictsUI.data('context');
        CS.body.on('Refreshed', '#GridViewSchedules', function (e, gridView) {
            gridViewSchedules = gridView;
        });
        CS.body.on('Refreshed', '#GridViewConflicts', function (e, gridView) {
            gridViewConflicts = gridView;
        });
        var autoRefreshTimer = null;
        //au load de la page, vérifier si la case est déjà coché
        if ($('#ScheduleParams_AutoRefresh').length > 0) {
            var autorefresh = $('#ScheduleParams_AutoRefresh')[0].checked;
            if (autorefresh) {
                autoRefreshTimer = setInterval(function () {
                    RefreshSchedules();
                }, 60000); //après ça, l'appeler aux 1 minutes
            }
        }
        $('#ScheduleParams_AutoRefresh').on('CSChange', function (e, element) {
            e.preventDefault();
            var isChecked = element.CheckPart.checked;
            var data = {
                autoRefresh: element.CheckPart.checked
            };
            CompuSport.Ajax.Post(CSParameters.ControllerUrl + 'SaveUserParamsAutoRefresh/' + CSParameters.SportEventId, data, function () {
            });
            if (isChecked) {
                autoRefreshTimer = setInterval(function () {
                    RefreshSchedules();
                }, 60000); //après ça, l'appeler aux 1 minutes
            }
            else {
                clearInterval(autoRefreshTimer);
            }
        });
        if (desktop.pendingChanges.val() == "True") {
            OnPendingChanges(true);
        }
        $('#BtnRefresh').on('click', 'a', function (e) {
            e.preventDefault();
            RefreshSchedules();
            //setInterval(function () {
            //RefreshSchedules();
            //}, 1000);
        });
        CompuSport.DOM.body.on("ajaxformready", onControlIsLoaded);
        function onControlIsLoaded() {
            $("#DeleteEncounters").controlIsLoaded(function (ajaxForm) {
                ajaxForm.OnAjaxSubmiting = function () {
                    var currentForm = $("#DeleteEncounters");
                    //CompuSport.Controls.ShowUserValidatorPopup(currentForm, function () {
                    //    currentForm.submit();
                    //});
                    callValidationPopup(currentForm);
                    return false;
                };
            });
        }
        function callValidationPopup(currentForm) {
            let formPopup = currentForm.data("popupcontext");
            if (((document.IsDeleteOpponent) == undefined) || (!document.IsDeleteOpponent.val())) {
                currentForm.append('<input type="hidden" value= "1f0b0ca0-1543-412e-93dd-1aafb73c6983" name="UserValidatorToken" />');
                //currentForm.off('postform');
                //formPopup.PostForm();
                currentForm.trigger('postform');
                //formPopup.Close();
                return;
            }
            let popup = new CompuSport.Controls.Popup();
            popup.GetAndShow({
                PopupId: 'PasswordValidator',
                Url: CSParameters.BaseUrl + 'Schedules/PasswordConfirmation/',
                Async: false,
                AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
            });
            popup.OnPosted = function (response) {
                currentForm.append('<input type="hidden" value= "1f0b0ca0-1543-412e-93dd-1aafb73c6983" name="UserValidatorToken" />');
                //currentForm.off('postform');
                currentForm.trigger('postform');
                //formPopup.PostForm();
                //formPopup.Close();
            };
        }
        function OnPendingChanges(hasChanged) {
            if (hasChanged) {
                desktop.pendingChanges.val("True");
                btnSaveChanges.removeClass('IsDisabled');
                btnCancelChanges.removeClass('IsDisabled');
                btnFlipEncounters.addClass('IsDisabled');
                btnFlipOpponents.addClass('IsDisabled');
            }
            else {
                desktop.pendingChanges.val("False");
                btnSaveChanges.addClass('IsDisabled');
                btnCancelChanges.addClass('IsDisabled');
                btnFlipEncounters.removeClass('IsDisabled');
                btnFlipOpponents.removeClass('IsDisabled');
            }
        }
        btnSaveChanges.on('click', 'a', function (e) {
            e.preventDefault();
            SaveSchedules_Tmp(false);
        });
        btnCancelChanges.on('click', 'a', function (e) {
            e.preventDefault();
            SaveSchedules_Tmp(true);
        });
        btnFlipEncounters.on('click', 'a', function (e) {
            e.preventDefault();
            var data = {
                encounterRowIds: GetSelectedEncounterRowsIds(),
                Post: true
            };
            let popup = new CompuSport.Controls.Popup();
            popup.GetAndShow({
                PopupId: "SwitchTwoEncounters",
                Url: CSParameters.RUrl + GetControllerName() + '/SwitchTwoEncounters/' + CSParameters.SportEventId,
                Data: data,
                AjaxCallType: CompuSport.Ajax.AjaxCallType.POST
            });
            popup.OnPosted = function (response) {
                UpdateElementsFromPost(response);
                btnFlipEncounters.addClass('IsDisabled');
            };
            /*
            ShowFormPopup(CSParameters.RUrl + GetControllerName() + '/SwitchTwoEncounters/' + CSParameters.SportEventId, data, null, function (response) {
                UpdateElementsFromPost(response);
                btnFlipEncounters.addClass('IsDisabled');
                $(this).dialog("close");
            });
            */
        });
        btnFlipOpponents.on('click', 'a', function (e) {
            e.preventDefault();
            CompuSport.Controls.Popup.ShowConfirmDialogV2('', JSRess.AreYouSure, function () {
                var data = {
                    encounterRowIds: GetSelectedEncounterRowsIds(),
                    groupId: undefined,
                    attemptId: undefined,
                    createGroupSurface: undefined
                };
                var updateFilter = $('#updateFilter');
                if (updateFilter != null && updateFilter.length > 0 && updateFilter.val() == "true") {
                    data.groupId = $('#PreSchedulesActualGroupId').val();
                    data.attemptId = $('#PreSchedulesActualAttemptId').val();
                    data.createGroupSurface = $('#CreateGroupSurface').val();
                }
                CompuSport.Ajax.Post(CSParameters.RUrl + GetControllerName() + "/SwitchHomeAndAway/" + CSParameters.SportEventId, data, function (response) {
                    UpdateElementsFromPost(response);
                    btnFlipOpponents.addClass('IsDisabled');
                });
            });
            //var result = ShowConfirmDialog();
            //result.Ok = function () {
            //    var data = {};
            //    data.encounterRowIds = GetSelectedEncounterRowsIds();
            //    var updateFilter = $('#updateFilter');
            //    if (updateFilter != null && updateFilter.length > 0 && updateFilter.val() == "true") {
            //        data.groupId = $('#PreSchedulesActualGroupId').val();
            //        data.attemptId = $('#PreSchedulesActualAttemptId').val();
            //    }
            //    $.ajaxAntiForgery({
            //        cache: false,
            //        type: "POST",
            //        url: CSParameters.RUrl + GetControllerName() + "/SwitchHomeAndAway/" + CSParameters.SportEventId,
            //        data: data,
            //        success: function (response) {
            //            UpdateElementsFromPost(response);
            //            btnFlipOpponents.addClass('IsDisabled');
            //        }
            //    });
            //};
        });
        btnShowScore.on('click', 'a', function (e) {
            e.preventDefault();
            var data = GetSelectedEncounterRowIdData();
            ShowScorePopup(data);
        });
        btnShowTeamDetail.on('click', 'a', function (e) {
            e.preventDefault();
            var popup = new CompuSport.Controls.Popup();
            popup.GetAndShow({
                PopupId: "ShowTeamDetails",
                Url: CSParameters.RUrl + GetControllerName() + '/ShowEncounterDetail/' + CSParameters.SportEventId,
                Data: GetSelectedEncounterRowIdData(),
                AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
            });
        });
        btnShowScanDetail.on('click', 'a', function (e) {
            e.preventDefault();
            let popup = new CompuSport.Controls.Popup();
            popup.GetAndShow({
                PopupId: "ShowScanDetail",
                Url: CSParameters.RUrl + GetControllerName() + '/ShowScanDetail/' + CSParameters.SportEventId,
                Data: GetSelectedEncounterRowIdData(),
                AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
            });
            //ShowFormPopup(CSParameters.RUrl + GetControllerName() + '/ShowScanDetail/' + CSParameters.SportEventId, GetSelectedEncounterRowIdData());
        });
        btnShowCallMatchDetail.on('click', 'a', function (e) {
            e.preventDefault();
            let popup = new CompuSport.Controls.Popup();
            popup.GetAndShow({
                PopupId: "ShowMatchCallCount",
                Url: CSParameters.RUrl + GetControllerName() + '/ShowMatchCallCount/' + CSParameters.SportEventId,
                Data: GetSelectedEncounterRowIdData(),
                AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
            });
            //ShowFormPopup(CSParameters.RUrl + GetControllerName() + '/ShowMatchCallCount/' + CSParameters.SportEventId, GetSelectedEncounterRowIdData());
        });
        btnOffsetSchedule.on('click', 'a', function (e) {
            e.preventDefault();
            let popup = new CompuSport.Controls.Popup();
            popup.GetAndShow({
                PopupId: "OffsetSchedule",
                Url: CSParameters.RUrl + GetControllerName() + '/OFFsetSchedule/' + CSParameters.SportEventId,
                /*Data: GetSelectedEncounterRowIdData(),*/
                AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
            });
        });
        btnConflicts.on('click', 'a', function (e) {
            e.preventDefault();
            checkAllConflictClicked = true; //maintenant, ca le fait automatique...
            let popup = new CompuSport.Controls.Popup();
            popup.GetAndShow({
                PopupId: "Conflicts",
                Url: CSParameters.RUrl + GetControllerName() + '/Conflicts/' + CSParameters.SportEventId,
                Data: GetSelectedEncounterRowIdData(),
                AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
            });
            popup.OnClosing = function () {
                if (checkAllConflictClicked) {
                    RefreshSchedules();
                    checkAllConflictClicked = false;
                }
            };
        });
        btnSeeConflicts.on('click', 'a', function (e) {
            e.preventDefault();
            let data = GetSelectedEncounterRowIdData();
            data.CheckConflict = false;
            data.ShowEncounterDetail = true;
            checkAllConflictClicked = false; //maintenant, ca le fait automatique...
            let popup = new CompuSport.Controls.Popup();
            popup.GetAndShow({
                PopupId: "",
                Url: CSParameters.RUrl + GetControllerName() + '/Conflicts/' + CSParameters.SportEventId,
                Data: data,
                AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
            });
            popup.OnClosing = function () {
                if (checkAllConflictClicked) {
                    RefreshSchedules();
                    checkAllConflictClicked = false;
                }
            };
        });
        btnShowBrackets.on('click', 'a', function (e) {
            e.preventDefault();
            let popup = new CompuSport.Controls.Popup();
            popup.GetAndShow({
                PopupId: "",
                Url: CSParameters.RUrl + GetControllerName() + '/ShowBrackets/' + CSParameters.SportEventId,
                Data: GetSelectedEncounterRowIdData(),
                AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
            });
        });
        btnForcePrintSelected.on('click', 'a', function (e) {
            e.preventDefault();
            var data = PrepareData();
            data.documentToPrint = "MatchCard";
            var controllername = GetControllerName();
            ForcePrint(data, controllername, function (result) {
            }, function (res) {
                if (res != "") {
                    if (controllername == 'SurfacesScheduler') {
                        Scheduler.desktop.UpdateSchedulerFromPost(res);
                    }
                    else {
                        gridViewSchedules.UpdateRowsFromPost(res);
                    }
                }
            });
        });
        let popup = null;
        btnCallMatchTable.on('click', 'a', function (e) {
            e.preventDefault();
            popup = new CompuSport.Controls.Popup();
            popup.GetAndShow({
                PopupId: "CallTable",
                Url: CSParameters.RUrl + GetControllerName() + '/CallMatchByTable/' + CSParameters.SportEventId,
                AjaxCallType: CompuSport.Ajax.AjaxCallType.POST
            });
        });
        btnChangeSurface.on('click', 'a', function (e) {
            e.preventDefault();
            var data = PrepareData();
            let popup = new CompuSport.Controls.Popup();
            popup.GetAndShow({
                PopupId: 'GetEncounterPopup',
                Url: CSParameters.RUrl + GetControllerName() + '/ChangeSurface/' + CSParameters.SportEventId,
                Data: data,
                AjaxCallType: CompuSport.Ajax.AjaxCallType.POST
            });
            popup.OnPosted = function (response) {
                UpdateElementsFromPost(response);
            };
            popup.OnClosing = function () {
                CompuSport.Ajax.Post(CSParameters.RUrl + GetControllerName() + "/UnlockManualContinuousPlay/" + CSParameters.SportEventId, data, function (response) {
                });
            };
        });
        btnRemoveCheckIn.on('click', 'a', function (e) {
            e.preventDefault();
            var data = PrepareData();
            CompuSport.Ajax.Post(CSParameters.RUrl + GetControllerName() + "/RemoveMatchCheckIn/" + CSParameters.SportEventId, data, function (response) {
                if (isSchedulerMode) {
                    //UpdateSchedulerFromPost(response);
                }
                else {
                    gridViewSchedules.UpdateRowsFromPost(response);
                }
                CompuSport.Controls.Popup.ShowWarningDialog('CheckIn Removed!!');
            });
        });
        btnChangeMatchNumber.on('click', 'a', function (e) {
            e.preventDefault();
            var data = PrepareData();
            let popup = new CompuSport.Controls.Popup();
            popup.GetAndShow({
                PopupId: 'GetEncounterPopup',
                Url: CSParameters.RUrl + "Schedules/EditMatchId/" + CSParameters.SportEventId,
                Data: data,
                AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
            });
        });
        btnCallMatchExcel.on('click', 'a', function (e) {
            e.preventDefault();
            var data = PrepareData();
            data.openExcel = true;
            CompuSport.Ajax.GetBlobPost(CSParameters.RUrl + GetControllerName() + "/CallSelectedMatches/" + CSParameters.SportEventId, data, function (response) {
                gridViewSchedules.RefreshGridData();
                CompuSport.Controls.Popup.ShowWarningDialog('Match called!!');
            });
        });
        btnCallMatch.on('click', 'a', function (e) {
            e.preventDefault();
            var data = PrepareData();
            CompuSport.Ajax.Post(CSParameters.RUrl + GetControllerName() + "/CallSelectedMatches/" + CSParameters.SportEventId, data, function (response) {
                if (isSchedulerMode) {
                    //UpdateSchedulerFromPost(response);
                }
                else {
                    gridViewSchedules.UpdateRowsFromPost(response);
                }
                CompuSport.Controls.Popup.ShowWarningDialog('Match called!!');
            });
        });
        btnShowScoreKeeperInfo.on('click', 'a', function (e) {
            e.preventDefault();
            let popup = new CompuSport.Controls.Popup();
            popup.GetAndShow({
                PopupId: "",
                Url: CSParameters.RUrl + 'PendingScoreSheets/ShowScoreKeeperInfo/' + CSParameters.SportEventId,
                Data: GetSelectedEncounterRowIdData(),
                AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
            });
            //ShowFormPopup(CSParameters.RUrl + 'PendingScoreSheets/ShowScoreKeeperInfo/' + CSParameters.SportEventId, GetSelectedEncounterRowIdData());
        });
        btnEraseConflicts.on('click', 'a', function (e) {
            e.preventDefault();
            var data = PrepareData();
            CompuSport.Ajax.Post(CSParameters.RUrl + GetControllerName() + "/UnFlagConflicts/" + CSParameters.SportEventId, data, function (response) {
                if (isSchedulerMode) {
                    Scheduler.desktop.UpdateSchedulerFromPost(response);
                }
                else {
                    gridViewSchedules.UpdateRowsFromPost(response);
                }
            });
        });
        btnUnPrintSelected.on('click', 'a', function (e) {
            e.preventDefault();
            var data = PrepareData();
            CompuSport.Ajax.Post(CSParameters.RUrl + GetControllerName() + "/UnPrintSelected/" + CSParameters.SportEventId, data, function (response) {
                if (isSchedulerMode) {
                    Scheduler.desktop.UpdateSchedulerFromPost(response);
                }
                else {
                    gridViewSchedules.UpdateRowsFromPost(response);
                }
            });
        });
        var $btnAddSchedulesDates = $('#BtnAddSchedulesDates');
        if ($btnAddSchedulesDates != null && $btnAddSchedulesDates.length > 0) {
            $btnAddSchedulesDates.on('click', 'a', function (e) {
                e.preventDefault();
                let ctl = new CompuSport.ContextControls.AddSchedulesDates();
                let groupId = 3;
                ctl.Show(groupId);
            });
        }
        btnRecalculateSelectedScoreSheets.on('click', 'a', function (e) {
            e.preventDefault();
            let popup = new CompuSport.Controls.Popup();
            let content = "<div> Do you want to update the players handicap of all players because this can replace manual handicap entered for player? </div>";
            content += "<button class='PopupButtons' value='yes'>Yes</button>";
            content += "<button class='PopupButtons' value='no'>No</button>";
            content += "<button class='PopupButtons' value='cancel'>Cancel</button>";
            popup.Show(content, { PopupId: 'ConfirmDialog', Title: '' });
            popup.OnButtonClicked = function (clickedButton) {
                if (clickedButton.val() == "yes") {
                    RecalculateSelectedScoreSheets(true);
                }
                if (clickedButton.val() == "no") {
                    RecalculateSelectedScoreSheets(false);
                }
            };
            //var result = ShowConfirmDialog('Do you want to include the calculation of all handicaps because this can replace manual handicap entries?', {
            //    "Yes": function () {
            //        RecalculateSelectedScoreSheets(true);
            //        $(this).dialog("close");
            //    },
            //    "No": function () {
            //        RecalculateSelectedScoreSheets(false);
            //        $(this).dialog("close");
            //    },
            //    "Cancel": function () {
            //        $(this).dialog("close");
            //        return;
            //    }
            //});
        });
        function RecalculateSelectedScoreSheets(includeCalculOfHandicaps) {
            var data = {
                encounterRowIds: GetSelectedEncounterRowsIds(),
                includeCalculOfHandicaps: includeCalculOfHandicaps
            };
            CompuSport.Ajax.Post(CSParameters.RUrl + GetControllerName() + "/RecalculateScoreSheets/" + CSParameters.SportEventId, data, function (response) {
                if (isSchedulerMode) {
                    Scheduler.desktop.UpdateSchedulerFromPost(response);
                }
                else {
                    gridViewSchedules.UpdateRowsFromPost(response);
                }
            });
        }
        btnAssignAndOptimizeMatches.on('click', 'a', function (e) {
            e.preventDefault();
            var data = {
                encounterRowIds: GetSelectedEncounterRowsIds()
            };
            CompuSport.Ajax.Post(CSParameters.RUrl + GetControllerName() + "/OptimizeAndAssign/" + CSParameters.SportEventId, data, function (queryResult) {
                $('.SchItem.Conf').removeClass('Conf');
                if (queryResult.msg != "") {
                    alert(queryResult.msg);
                }
                var list = queryResult.ids;
                for (var i = 0; i < list.length; i++) {
                    var sch = $('#E' + list[i]);
                    sch.addClass('Conf');
                }
                RefreshSchedules();
            });
        });
        btnSendToOtherEvent.on('click', 'a', function (e) {
            e.preventDefault();
            var data = {
                encounterRowIds: GetSelectedEncounterRowsIds()
            };
            CompuSport.Controls.Popup.ShowConfirmDialogV2('', "Enter SportEventId to copy to <input class='CSDefault' type='text' id='sportEventId'/>", function (popup) {
                var text = $('#sportEventId', popup.Content).val();
                var data = {
                    encounterRowIds: GetSelectedEncounterRowsIds(),
                    eventIdToCopy: text
                };
                CompuSport.Ajax.Post(CSParameters.ControllerUrl + "CreateFakeEncounterInOtherEvent/" + CSParameters.SportEventId, data, function (queryResult) {
                    if (!(typeof queryResult.errors === "undefined")) {
                        alert(queryResult.errors);
                    }
                    else {
                        alert('Done');
                    }
                });
            });
        });
        btnTwinCorrector.on('click', 'a', function (e) {
            e.preventDefault();
            var data = {
                encounterRowId: GetSelectedEncounterRowsIds().replace(",", ""), // GetSelectedIds().replace(",", "");
                attemptId: $('#PreSchedulesActualAttemptId').val()
            };
            CompuSport.Ajax.Post(CSParameters.RUrl + GetControllerName() + "/TwinCorrection/" + CSParameters.SportEventId, data, function (queryResult) {
                $('.SchItem.Conf').removeClass('Conf');
                var list = queryResult.ids;
                for (var i = 0; i < list.length; i++) {
                    var sch = $('#E' + list[i]);
                    sch.addClass('Conf');
                }
            });
        });
        btnScoreSheetAdvanced.on('click', 'a', function (e) {
            e.preventDefault();
            var data = {
                encounterRowId: GetSelectedEncounterRowsIds().replace(",", "")
            };
            let popup = new CompuSport.Controls.Popup();
            popup.GetAndShow({
                PopupId: "",
                Url: CSParameters.RUrl + 'Scores/ScoreSheetAdvanced/' + CSParameters.SportEventId,
                Data: data,
                AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
            });
        });
        btnShowBracket.on('click', function (e) {
            e.preventDefault();
            var encounterRowId = GetSelectedEncounterRowIdData().encounterRowId;
            var data = {
                ids: encounterRowId
            };
            CompuSport.Ajax.Post(CSParameters.RUrl + 'Schedules/GetSchedulesByIds', data, function (response) {
                var fbid = response[0].FlowBlockId;
                let isBracket = response[0].IsBracket;
                let entityBaseId = response[0].EntityId;
                let selectedEncounterRowId = response[0].EncounterRowId;
                LoadChartFromAdvancing(fbid, isBracket, entityBaseId, selectedEncounterRowId);
            });
        });
        function LoadChartFromAdvancing(flowBlockId, isBracket, entityBaseId, selectedEncounterRowId) {
            let data = {};
            data.flowBlockId = flowBlockId;
            data.highlightedEntityBaseId = entityBaseId;
            data.isBracket = isBracket;
            data.highlightedDrawPosition = null;
            data.selectedEncounterRowId = selectedEncounterRowId;
            CompuSport.Ajax.Get(CSParameters.RUrl + "Charts/Chart/" + CSParameters.SportEventId, data, function (queryResult) {
                masterContainerOverEverything.slideDown(250, function () {
                    UpdateChart(queryResult, false);
                    RegisterBracketInfoEventsFromAdvancing();
                });
            });
        }
        function RegisterBracketInfoEventsFromAdvancing() {
            let btnCloseCanvasContainer = $('.CSZoomCanvasControlPanel .Close');
            btnCloseCanvasContainer.off('mousedown');
            btnCloseCanvasContainer.on('mousedown', function (e) {
                e.preventDefault();
                document.CanvasChart.ClearContent();
                masterContainerOverEverything.slideUp(250, 'swing', function () {
                });
            });
        }
        function RefreshScheduledDates() {
            CompuSport.Ajax.Get(CSParameters.RUrl + GetControllerName() + "/GetScheduledDates/" + CSParameters.SportEventId, null, function (queryResult) {
                ScheduledDates = queryResult.HighlightedDates;
                if (queryResult.StartDate != "") {
                    /*    (<any>document).StartDate.CSDatePicker.datepicker('setDate', queryResult.StartDate);
                        var endDatePicker = (<any>document).EndDate.CSDatePicker;
                        var actualEndDate = endDatePicker.datepicker('getDate');
                        endDatePicker.datepicker("option", "minDate", queryResult.StartDate);*/
                }
                if (queryResult.EndDate != "") {
                    /*
                     *  (<any>document).EndDate.CSDatePicker.datepicker('setDate', queryResult.EndDate);
                     *
                     */
                }
                document.StartDate.InputBox.datepicker('refresh');
                document.EndDate.InputBox.datepicker('refresh');
            });
        }
        function SaveSchedules_Tmp(cancel) {
            var isPrinted = false;
            CompuSport.Ajax.Post(CSParameters.RUrl + GetControllerName() + "/GetScheduleTmpIsPrinted/" + CSParameters.SportEventId, null, function (queryResult) {
                isPrinted = queryResult.IsPrinted;
                var reprintMatchCard = false;
                if (isPrinted) {
                    reprintMatchCard = confirm(queryResult.Message);
                }
                let $lastRefreshedTimestamp = $('#lastrefreshedtimestamp');
                let lastRefreshedTimestampVal = -1;
                if ($lastRefreshedTimestamp.length > 0) {
                    lastRefreshedTimestampVal = $lastRefreshedTimestamp.val();
                }
                //pose une question is isPrinted est a true.
                var data = {
                    cancel: cancel,
                    lastRefreshedTimestamp: lastRefreshedTimestampVal,
                    reprintMatchCard: reprintMatchCard
                };
                CompuSport.Ajax.Post(CSParameters.RUrl + GetControllerName() + "/SaveSchedules_Tmp/" + CSParameters.SportEventId, data, function (queryResult) {
                    if (queryResult) {
                        ShowChangeElseWhereMessageWarning(queryResult);
                    }
                    RefreshSchedules();
                    OnPendingChanges(false);
                });
            });
        }
        var hiddenWhenFiltered = $('#HiddenWhenFiltered');
        $(function () {
            if (document.StartDate != null) {
                document.StartDate.SelectionChange = function (sender) {
                    if (gridViewSchedules != undefined) {
                        gridViewSchedules.UnselectAllRows(); //Important, sinon, les boutons du hauts reste bindés sur la derniere ligne sélectionné
                    }
                    var endDatePicker = document.EndDate.CSDatePicker;
                    var actualEndDate = endDatePicker.datepicker('getDate');
                    endDatePicker.datepicker("option", "minDate", this.ActualSelectedDate);
                    actualEndDate.setFullYear(actualEndDate.getFullYear() - this.OffsetYear);
                    actualEndDate.setMonth(actualEndDate.getMonth() - this.OffsetMonth);
                    actualEndDate.setDate(actualEndDate.getDate() - this.OffsetDay);
                    document.EndDate.CSDatePicker.datepicker('setDate', actualEndDate);
                    RefreshSchedules();
                };
                document.EndDate.SelectionChange = function () {
                    if (gridViewSchedules != undefined) {
                        gridViewSchedules.UnselectAllRows(); //Important, sinon, les boutons du hauts reste bindés sur la derniere ligne sélectionné
                    }
                    RefreshSchedules();
                };
                if (!(typeof gridViewSchedules === "undefined")) {
                    gridViewSchedules.SelectionChange = function () {
                        var idsStr = gridViewSchedules.GetSelectedRowIds();
                        if (idsStr != "") {
                            desktop.selectedIds = gridViewSchedules.GetSelectedRowIds().split(",");
                        }
                        else {
                            desktop.selectedIds.length = 0;
                        }
                        UpdateToolBarButtons();
                    };
                    gridViewSchedules.OverrideDeleteButton = function () {
                        var data = {
                            encounterRowIds: GetSelectedEncounterRowsIds(),
                            Post: true
                        };
                        let popup = new CompuSport.Controls.Popup();
                        popup.GetAndShow({
                            PopupId: "DeleteEncountersPopup",
                            Url: CSParameters.RUrl + GetControllerName() + '/DeleteEncountersPopup/' + CSParameters.SportEventId,
                            Data: data,
                            AjaxCallType: CompuSport.Ajax.AjaxCallType.POST
                        });
                        //popup.OnButtonClicked = function (button, buttonVal) {
                        //    if (buttonVal == "ok")
                        //        $("#DeleteEncounters").submit()
                        //}
                        popup.OnPosted = function (result) {
                            UpdateElementsFromPost(result);
                        };
                        /*
                        ShowFormPopup(CSParameters.RUrl + GetControllerName() + '/DeleteEncountersPopup/' + CSParameters.SportEventId, data, null, function (result) {
                            UpdateElementsFromPost(result);
                            $(this).dialog("close");
                        });
                        */
                    };
                    gridViewSchedules.OverrideAddButton = function () {
                        AddSchedule();
                    };
                    gridViewSchedules.OverrideEditButton = function () {
                        EditSchedules();
                    };
                    gridViewSchedules.ExtendPrepareData = function (data) {
                        PrepareData(data);
                    };
                    gridViewSchedules.Refreshed = function (response) {
                        ExtractFilterMessageCount(response);
                    };
                    $('#TxtMasterSearchAutoComplete').focus();
                }
            }
            var startDatePicker = document.StartDate.CSDatePicker;
            var endDatePicker = document.EndDate.CSDatePicker;
            endDatePicker.datepicker("option", "minDate", startDatePicker.datepicker('getDate'));
        });
        function AddSchedule() {
            let popup = new CompuSport.Controls.Popup();
            popup.GetAndShow({
                PopupId: "",
                Url: CSParameters.RUrl + GetControllerName() + '/AddGridViewSchedules/' + CSParameters.SportEventId,
                AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
            });
            popup.OnPosted = function (result) {
                //Si form length est plus grand que 0, cela indique qu'il ya une erreur et qu'elle doit etre affiché dans la popup, donc, c'Est pourquoi il ne faut pas la fermer
                if ($('form', result).length == 0) {
                    UpdateElementsFromPost(result);
                }
            };
            /*
            ShowFormPopup(CSParameters.RUrl + GetControllerName() + '/AddGridViewSchedules/' + CSParameters.SportEventId, null, null, function (result) {
                //Si form length est plus grand que 0, cela indique qu'il ya une erreur et qu'elle doit etre affiché dans la popup, donc, c'Est pourquoi il ne faut pas la fermer
                if ($('form', result).length == 0) {
                    UpdateElementsFromPost(result);
                    $(this).dialog("close");
                }
            });
            */
        }
        desktop.AddSchedule = AddSchedule;
        function EditSchedules() {
            var data = {
                ids: GetSelectedEncounterRowsIds(),
                Post: true
            };
            if (isSchedulerMode && IsDefined(typeof (Scheduler)) && IsDefined(typeof (Scheduler.desktop.ClearLinks))) {
                Scheduler.desktop.ClearLinks();
            }
            let popup = new CompuSport.Controls.Popup();
            popup.GetAndShow({
                PopupId: "",
                Url: CSParameters.RUrl + GetControllerName() + '/EditGridViewSchedules/' + CSParameters.SportEventId,
                Data: data,
                AjaxCallType: CompuSport.Ajax.AjaxCallType.POST
            });
            popup.OnPosted = function (result) {
                //Si form length est plus grand que 0, cela indique qu'il ya une erreur et qu'elle doit etre affiché dans la popup, donc, c'Est pourquoi il ne faut pas la fermer
                if ($('form', result).length == 0) {
                    UpdateElementsFromPost(result);
                }
            };
            /*
            ShowFormPopup(CSParameters.RUrl + GetControllerName() + '/EditGridViewSchedules/' + CSParameters.SportEventId, data, null, function (result) {
                //Si form length est plus grand que 0, cela indique qu'il ya une erreur et qu'elle doit etre affiché dans la popup, donc, c'Est pourquoi il ne faut pas la fermer
                if ($('form', result).length == 0) {
                    UpdateElementsFromPost(result);
                    $(this).dialog("close");
                }
            });
            */
        }
        desktop.EditSchedules = EditSchedules;
        function GetSelectedEncounterRowsIds() {
            if (desktop.selectedIds.length > 0) {
                return desktop.selectedIds.join(',').toString();
            }
            return '';
        }
        desktop.GetSelectedEncounterRowsIds = GetSelectedEncounterRowsIds;
        function GetSelectedEncounterRowIdData() {
            var data = {
                encounterRowId: desktop.selectedIds[0]
            };
            return data;
        }
        function AddEToEncounterRowId(encounterRowId) {
            return 'E' + encounterRowId;
        }
        desktop.AddEToEncounterRowId = AddEToEncounterRowId;
        function UpdateToolBarButtons() {
            var _a, _b, _c, _d, _e;
            btnShowScoreKeeperInfo.addClass('IsDisabled');
            btnChangeSurface.addClass('IsDisabled');
            btnChangeMatchNumber.addClass('IsDisabled');
            btnRemoveCheckIn.addClass('IsDisabled');
            btnForcePrintSelected.addClass('IsDisabled');
            btnUnPrintSelected.addClass('IsDisabled');
            btnSeeConflicts.addClass('IsDisabled');
            btnShowBrackets.addClass('IsDisabled');
            btnSendToOtherEvent.addClass('IsDisabled');
            btnShowScore.addClass('IsDisabled');
            btnShowTeamDetail.addClass('IsDisabled');
            btnShowScanDetail.addClass('IsDisabled');
            btnShowCallMatchDetail.addClass('IsDisabled');
            btnFlipOpponents.addClass('IsDisabled');
            btnFlipEncounters.addClass('IsDisabled');
            btnTwinCorrector.addClass('IsDisabled');
            btnShowBracket.addClass('IsDisabled');
            btnAssignAndOptimizeMatches.addClass('IsDisabled');
            btnScoreSheetAdvanced.addClass('IsDisabled');
            btnRecalculateSelectedScoreSheets.addClass('IsDisabled');
            btnCallMatch.addClass('IsDisabled');
            btnCallMatchExcel.addClass('IsDisabled');
            if (isSchedulerMode) {
                if ((_a = Scheduler === null || Scheduler === void 0 ? void 0 : Scheduler.desktop) === null || _a === void 0 ? void 0 : _a.btnEditScheduler) {
                    Scheduler.desktop.btnEditScheduler.hide();
                }
                if ((_b = Scheduler === null || Scheduler === void 0 ? void 0 : Scheduler.desktop) === null || _b === void 0 ? void 0 : _b.btnDeleteFromScheduler) {
                    Scheduler.desktop.btnDeleteFromScheduler.hide();
                }
            }
            if (desktop.selectedIds.length >= 1) {
                btnSendToOtherEvent.removeClass('IsDisabled');
                btnForcePrintSelected.removeClass('IsDisabled');
                btnUnPrintSelected.removeClass('IsDisabled');
                btnCallMatch.removeClass('IsDisabled');
                btnCallMatchExcel.removeClass('IsDisabled');
                btnRecalculateSelectedScoreSheets.removeClass('IsDisabled');
                btnTwinCorrector.removeClass('IsDisabled');
                btnAssignAndOptimizeMatches.removeClass('IsDisabled');
                btnRemoveCheckIn.removeClass('IsDisabled');
                if (isSchedulerMode) {
                    if ((_c = Scheduler === null || Scheduler === void 0 ? void 0 : Scheduler.desktop) === null || _c === void 0 ? void 0 : _c.btnEditScheduler) {
                        Scheduler.desktop.btnEditScheduler.show();
                    }
                    if ((_d = Scheduler === null || Scheduler === void 0 ? void 0 : Scheduler.desktop) === null || _d === void 0 ? void 0 : _d.btnDeleteFromScheduler) {
                        Scheduler.desktop.btnDeleteFromScheduler.show();
                    }
                }
            }
            if (desktop.selectedIds.length == 1) {
                if (isSchedulerMode) {
                    if (!((_e = Scheduler === null || Scheduler === void 0 ? void 0 : Scheduler.desktop) === null || _e === void 0 ? void 0 : _e.isAttempt)) {
                        btnShowScore.removeClass('IsDisabled');
                    }
                }
                else {
                    btnShowScore.removeClass('IsDisabled');
                }
                btnShowScoreKeeperInfo.removeClass('IsDisabled');
                btnChangeSurface.removeClass('IsDisabled');
                btnChangeMatchNumber.removeClass('IsDisabled');
                btnSeeConflicts.removeClass('IsDisabled');
                btnScoreSheetAdvanced.removeClass('IsDisabled');
                btnShowTeamDetail.removeClass('IsDisabled');
                btnShowScanDetail.removeClass('IsDisabled');
                btnShowCallMatchDetail.removeClass('IsDisabled');
                btnShowBrackets.removeClass('IsDisabled');
                btnShowBracket.removeClass('IsDisabled');
                if (desktop.pendingChanges.val() != "True") {
                    btnFlipOpponents.removeClass('IsDisabled');
                }
            }
            else if (desktop.selectedIds.length == 2) {
                if (desktop.pendingChanges.val() != "True") {
                    btnFlipEncounters.removeClass('IsDisabled');
                }
            }
        }
        desktop.UpdateToolBarButtons = UpdateToolBarButtons;
        MasterPage.MasterSearch.show();
        MasterPage.MasterSearch.on('CSMasterSearch', function (e) {
            var data = MasterSearchKeyCodeAnalyser.desktop.GetScoreSheetCodeInMasterSearch();
            if (data != null) {
                e.stopPropagation();
                e.preventDefault();
                ShowScorePopup(data);
                return;
            }
            RefreshSchedules();
        });
        function ShowScorePopup(data) {
            if (data == null) {
                data = {};
            }
            CompuSport.Ajax.Get(CSParameters.RUrl + 'Scores/CheckIsNewScoreSheet/' + CSParameters.SportEventId, data, function (response) {
                PrepareData(data);
                data.elementToRefresh = GetElementToRefresh();
                //Patch qui évite un get avec trop de data qui fait peter un request length error dans la query string
                data.Parameters = null;
                if (response.isNewScoreSheet) {
                    var popup = new CompuSport.Controls.Popup();
                    popup.GetAndShow({
                        PopupId: "ScorePopup",
                        Url: CSParameters.RUrl + 'Scores/Popup/' + CSParameters.SportEventId,
                        Data: data,
                        AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
                    });
                    popup.OnPosted = function (response) {
                        UpdateElementsFromPost(response);
                    };
                    popup.OnClosed = function () {
                        if ($('#GridViewSchedules').length > 0) {
                            $('#TxtMasterSearchAutoComplete').focus();
                        }
                    };
                }
                else {
                    //let popup = new CompuSport.Controls.Popup();
                    //popup.GetAndShow({
                    //    PopupId: "",
                    //    Url: CSParameters.RUrl + 'Scores/Popup/' + CSParameters.SportEventId,
                    //    Data: data,
                    //    AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
                    //});
                    //popup.OnPosted = function (response) {
                    //    UpdateElementsFromPost(response);
                    //};
                    ShowFormPopup(CSParameters.RUrl + 'Scores/Popup/' + CSParameters.SportEventId, data, null, function (response, pressedButton) {
                        if (pressedButton != "EnterKey") {
                            UpdateElementsFromPost(response);
                            $(this).dialog('close');
                        }
                    });
                }
            });
        }
        CS.body.on('scoresheetupdated.schedules', function (e, response) {
            UpdateElementsFromPost(response);
        });
        function UpdateElementsFromPost(response) {
            if (response == "") {
                return;
            }
            OnPendingChanges(false);
            var schedulesTempCount = 0;
            var elsewhereMessage = '';
            var $response = $(response);
            var $schedulesTempCount = null;
            $response = $.grep($response, function (element) {
                if (element.tagName == "INPUT") {
                    if (element.id == 'SchedulesTempCount') {
                        $schedulesTempCount = $(element);
                    }
                    else if (element.id == 'changeelsewhere') {
                        elsewhereMessage = decodeURIComponent($(element).val());
                    }
                    return false;
                }
                else {
                    return true;
                }
            });
            if ($schedulesTempCount != null && $schedulesTempCount.length > 0) {
                var count = $schedulesTempCount.val();
                if (count > 0) {
                    OnPendingChanges(true);
                }
            }
            if (isSchedulerMode) {
                Scheduler.desktop.UpdateSchedulerFromPost($response);
            }
            else {
                gridViewSchedules.UpdateRowsFromPost($response);
            }
            if (elsewhereMessage) {
                ShowChangeElseWhereMessageWarning(elsewhereMessage);
            }
        }
        desktop.UpdateElementsFromPost = UpdateElementsFromPost;
        function ShowChangeElseWhereMessageWarning(message) {
            CompuSport.Controls.Popup.ShowWarningDialog('<div id="changeelsewheremessage">' + message + '</div>');
        }
        function CheckIfPendingChanges() {
        }
        function GetElementToRefresh() {
            if (isSchedulerMode) {
                return "Scheduler";
            }
            else {
                return "GridViewSchedules";
            }
        }
        function RefreshSchedules(createGroupSurface = false) {
            RefreshScheduledDates();
            var schedulesContainer = $('#SchedulesContainer');
            var saveSurfacesFilter = false;
            //a améliorer
            if (surfacesFilterContainer != null) {
                saveSurfacesFilter = true;
            }
            $('#CreateGroupSurface').val(String(createGroupSurface));
            if (isSchedulerMode) {
                // if (1==1) {
                var data = PrepareData();
                //  data.createGroupSurface = createGroupSurface;
                data.saveSurfacesFilter = saveSurfacesFilter;
                CompuSport.Ajax.Post(CSParameters.RUrl + GetControllerName() + "/RefreshGridViewSchedules/" + CSParameters.SportEventId, data, function (response) {
                    var $response = $(response);
                    schedulesContainer[0].innerHTML = $response[0].outerHTML;
                    Scheduler.desktop.BindScheduler();
                    ExtractFilterMessageCount($response);
                });
                if (IsDefined(typeof (SchedulingTool /*.desktop.RefreshRightPanelScheduler*/))) {
                    SchedulingTool.desktop.RefreshRightPanelScheduler();
                }
            }
            else {
                gridViewSchedules.AppendTo = schedulesContainer;
                gridViewSchedules.RefreshGridData();
                gridViewSchedules.GridView.removeClass('Hidden');
            }
        }
        desktop.RefreshSchedules = RefreshSchedules;
        var filterPanel = $('#FilterPanel');
        function PrepareData(data) {
            if (data == null) {
                data = {};
            }
            data.encounterRowIds = GetSelectedEncounterRowsIds();
            var scheduleParams = {
                MasterSearch: MasterPage.TxtMasterSearch.val(),
                StartDateTime: document.StartDate.val(),
                EndDateTime: document.EndDate.val(),
                AutoRefresh: $('#ScheduleParams_AutoRefresh').length > 0 ? $('#ScheduleParams_AutoRefresh')[0].checked : false,
                LoadFilterFromUserData: undefined,
                ClearFilter: undefined,
                StartTimeFilter: undefined,
                EndTimeFilter: undefined,
                DaysOfWeekFilter: undefined,
                DivisionsFilter: undefined,
                SurfacesFilter: undefined,
                SurfacesFilterId: undefined,
                HiddenWhenFiltered: undefined,
                ValuesDisplayedFilter: undefined,
                EncounterStatesFilter: undefined,
                PreScheduleGroupAttemptFilter: undefined,
                LinkModesFilter: undefined
            };
            if (!filterPanel.is(':visible')) {
                scheduleParams.LoadFilterFromUserData = true;
            }
            else {
                scheduleParams.LoadFilterFromUserData = false;
                scheduleParams.ClearFilter = $('#ClearFilter').val() === 'true';
                scheduleParams.StartTimeFilter = document.StartTimeFilter.val();
                scheduleParams.EndTimeFilter = document.EndTimeFilter.val();
                scheduleParams.DaysOfWeekFilter = ExtractDaysOfWeekFilter();
                scheduleParams.DivisionsFilter = ExtractDivisionsFilter();
                scheduleParams.SurfacesFilter = ExtractSurfacesFilter();
                let filterId = $('#SurfacesFilter').find('button').data('filterid');
                scheduleParams.SurfacesFilterId = filterId == "" ? null : filterId;
                scheduleParams.HiddenWhenFiltered = $('#HiddenWhenFiltered')[0].checked;
                scheduleParams.ValuesDisplayedFilter = ExtractValuesDisplayedFilter();
                scheduleParams.EncounterStatesFilter = ExtractEncounterStatesFilter();
                scheduleParams.PreScheduleGroupAttemptFilter = ExtractPreScheduleGroupAttemptFilter();
                scheduleParams.LinkModesFilter = ExtractLinkModesFilter();
            }
            //Ceci vient du preschedule qui faire en sorte que si l'on demande de mettre à jour le filtre
            //le groupId en question sera passé au filtre et ainsi, les parametres du filtre seront mise
            //a jour en fonction de ce group ou de ce attempt.
            var updateFilter = $('#updateFilter');
            var schedulesContainer = $('#SchedulesContainer');
            var saveSurfacesFilter = false;
            //a améliorer
            if (surfacesFilterContainer != null) {
                saveSurfacesFilter = true;
            }
            data.saveSurfacesFilter = saveSurfacesFilter;
            if (updateFilter != null && updateFilter.length > 0 && updateFilter.val() == "true") {
                data.groupId = $('#PreSchedulesActualGroupId').val();
                data.attemptId = $('#PreSchedulesActualAttemptId').val();
                data.createGroupSurface = $('#CreateGroupSurface').val();
                var showAllSchedules = $('#ShowAllSchedule');
                if (showAllSchedules != null && showAllSchedules.length > 0 && showAllSchedules.val() == "true") {
                    data.showAllSchedules = true;
                }
            }
            if (isSchedulerMode) {
                if (Scheduler.desktop.schedulerParams != null) {
                    Scheduler.desktop.schedulerParams.SelectedIds = GetSelectedEncounterRowsIds();
                    if ($('#SchedulerParams_ShowConstantPlaySurfaces').length > 0) {
                        Scheduler.desktop.schedulerParams.ShowConstantPlaySurfaces = $('#SchedulerParams_ShowConstantPlaySurfaces')[0].checked;
                    }
                    else {
                        Scheduler.desktop.schedulerParams.ShowConstantPlaySurfaces = false;
                    }
                    data.schedulerParams = JSON.stringify(Scheduler.desktop.schedulerParams);
                }
                else {
                    Scheduler.desktop.schedulerParams = {};
                    data.schedulerParams = '';
                }
            }
            else {
                if (typeof (gridViewSchedules) != 'undefined') {
                    data.Parameters = JSON.stringify(gridViewSchedules.Parameters);
                }
            }
            data.scheduleParams = JSON.stringify(scheduleParams);
            return data;
        }
        desktop.PrepareData = PrepareData;
        //#region Filter pane
        var btnShowFilterPane = $('#BtnShowFilterPane');
        var filterPanelItems = $('#FilterPanelItems');
        function GetControllerName() {
            return isSchedulerMode ? "SurfacesScheduler" : "Schedules";
        }
        desktop.GetControllerName = GetControllerName;
        btnShowFilterPane.on('click', function (e) {
            e.preventDefault();
            HidePreSchedulesPanel();
            if (!filterPanel.is(':visible')) {
                var data = {};
                CompuSport.Ajax.Post(CSParameters.RUrl + GetControllerName() + "/GetFilterPanel/" + CSParameters.SportEventId, data, function (queryResult) {
                    filterPanelItems[0].innerHTML = queryResult;
                    BindFilterPanelControls();
                    filterPanel.show("slide", { direction: "left" }, 250, function () {
                        if (IsDefined(typeof (CS.docHtml))) {
                            CS.docHtml.trigger('panelopened', filterPanel[0].id);
                        }
                    });
                    btnShowFilterPane.addClass("IsSelected");
                });
            }
            else {
                HideFilterPanel();
            }
        });
        var surfacesFilterContainer;
        function ShowHideSurfacesFilterPanel(clickedButton, onChangeCallback, forceReload = false) {
            let data = {
                filterId: clickedButton.data('filterid')
            };
            if (!forceReload && surfacesFilterContainer != null && surfacesFilterContainer.data('filterid') == data.filterId) {
                if (surfacesFilterContainer.is(':visible')) {
                    surfacesFilterContainer.slideUp(200);
                    return;
                }
                CS.PositionTargetRefToSourceAndWindows(clickedButton, surfacesFilterContainer);
                surfacesFilterContainer.slideDown();
                return;
            }
            CompuSport.Ajax.Get(CSParameters.RUrl + "Schedules/GetSurfacesFilterDropDown/" + CSParameters.SportEventId, data, function (response) {
                if (surfacesFilterContainer != null) {
                    surfacesFilterContainer.remove();
                }
                surfacesFilterContainer = $(response);
                surfacesFilterContainer.appendTo(CS.body);
                surfacesFilterContainer.find("input:checkbox").CSCheckBox();
                CS.PositionTargetRefToSourceAndWindows(clickedButton, surfacesFilterContainer);
                var surface_All = $('#Surface_All', surfacesFilterContainer);
                surface_All.off('CSChange');
                surface_All.on('CSChange', function (e) {
                    var checkAll = this.checked;
                    var checkBoxes = $('.SurfaceFilterRow input');
                    $.each(checkBoxes, function (e, element) {
                        if (element.id != 'Surface_All') {
                            element.checked = checkAll;
                            $(element).trigger('change');
                        }
                    });
                });
                surfacesFilterContainer.slideDown();
                surfacesFilterContainer.on('change', function () {
                    if (onChangeCallback != null) {
                        var ids = ExtractSurfacesFilter();
                        onChangeCallback.call(this, ids);
                    }
                });
                CS.body.off('mousedown.surfacesfilter');
                CS.body.on('mousedown.surfacesfilter', function (e) {
                    let $this = $(e.target);
                    if ($this.closest('.SurfacesFilterContainer').length > 0) {
                        return;
                    }
                    surfacesFilterContainer.slideUp(200, function () { });
                });
            });
        }
        desktop.ShowHideSurfacesFilterPanel = ShowHideSurfacesFilterPanel;
        function BindFilterPanelControls() {
            var filterPanel = $('#FilterPanelItems');
            var surfacesFilter = filterPanel.find('#SurfacesFilter');
            surfacesFilter.find('button').on('click', function () {
                let clickedButton = $(this);
                if (surfacesFilterContainer != null && surfacesFilterContainer.is(':visible')) {
                    return;
                }
                ShowHideSurfacesFilterPanel(clickedButton);
            });
            $('.CSDropDownCheckboxes').CSDropDownCheckboxes();
            var dayOfWeek_All = $('#DayOfWeek_All', filterPanel);
            dayOfWeek_All.off('CSChange');
            dayOfWeek_All.on('CSChange', function (e) {
                var checkAll = this.checked;
                var checkBoxes = $('.DayOfWeekFilterRow input');
                $.each(checkBoxes, function (e, element) {
                    if (element.id != 'DayOfWeek_All') {
                        element.checked = checkAll;
                        $(element).trigger('change');
                    }
                });
            });
            var division_All = $('#Division_All', filterPanel);
            division_All.off('CSChange');
            division_All.on('CSChange', function (e) {
                var checkAll = this.checked;
                var checkBoxes = $('.DivisionFilterRow input');
                $.each(checkBoxes, function (e, element) {
                    if (element.id != 'Division_All') {
                        element.checked = checkAll;
                        $(element).trigger('change');
                    }
                });
            });
            var encounter_All = $('#Encounter_All', filterPanel);
            encounter_All.off('CSChange');
            encounter_All.on('CSChange', function (e) {
                var checkAll = this.checked;
                var checkBoxes = $('.EncounterStateRowFilter input');
                $.each(checkBoxes, function (e, element) {
                    if (element.id != 'Encounter_All') {
                        element.checked = checkAll;
                        $(element).trigger('change');
                    }
                });
            });
            var value_All = $('#Value_All', filterPanel);
            value_All.off('CSChange');
            value_All.on('CSChange', function (e) {
                var checkAll = this.checked;
                var checkBoxes = $('.ValuesDisplayedFilterRow input');
                $.each(checkBoxes, function (e, element) {
                    if (element.id != 'Value_All') {
                        element.checked = checkAll;
                        $(element).trigger('change');
                    }
                });
            });
            var btnCloseFilterPane = $('#BtnCloseFilterPane', filterPanel);
            btnCloseFilterPane.off('click');
            btnCloseFilterPane.on('click', function (e) {
                e.preventDefault();
                btnShowFilterPane.trigger('click');
            });
            //$(filterPanel).off('mousedown.filterpanel');
            //$(filterPanel).on('mousedown.filterpanel', function (e) {
            //    e.preventDefault();
            //    e.stopPropagation();
            //});
            //body.off('mousedown.filterpanel');
            //body.on('mousedown.filterpanel', function () {
            //    HideFilterPanel();
            //})
            var btnApplyFilter = $('#BtnApplyFilter', filterPanel);
            btnApplyFilter.off('click');
            btnApplyFilter.on('click', function (e) {
                e.preventDefault();
                btnShowFilterPane.trigger('click');
                RefreshSchedules();
            });
            $('#BtnRestoreDefaults').off('click');
            $('#BtnRestoreDefaults').on('click', function (e) {
                e.preventDefault();
                MasterPage.TxtMasterSearch.val('');
                MasterPage.TxtMasterSearch.trigger('blur');
                $('#ClearFilter').val('true');
                btnShowFilterPane.trigger('click');
                RefreshSchedules();
            });
            $("input:checkbox", filterPanel).CSCheckBox();
            $('.CSTimePicker', filterPanel).CSTimePicker();
        }
        var btnPreSchedules = $('#BtnPreSchedules');
        var preSchedulesPanel = $('#PreSchedulesPanel');
        btnPreSchedules.on('click', function (e) {
            e.preventDefault();
            HideFilterPanel();
            if (!preSchedulesPanel.is(':visible')) {
                var data = {};
                CompuSport.Ajax.Post(CSParameters.RUrl + "SchedulesGenerator/PreSchedulesPanel/" + CSParameters.SportEventId, data, function (queryResult) {
                    preSchedulesPanel[0].innerHTML = queryResult;
                    SchedulesGenerator.desktop.BindPreSchedulesControls();
                    preSchedulesPanel.show("slide", { direction: "left" }, 250, function () {
                        if (IsDefined(typeof (CS.docHtml))) {
                            CS.docHtml.trigger('panelopened', preSchedulesPanel[0].id);
                        }
                        btnPreSchedules.addClass("IsSelected");
                    });
                });
            }
            else {
                HidePreSchedulesPanel();
            }
        });
        if ($('#RequestedSchedulingGroupId').val() && btnPreSchedules.length > 0) {
            btnPreSchedules.trigger('click');
        }
        function HideFilterPanel() {
            if (filterPanel.is(":visible")) {
                $('.SurfacesFilterContainer').hide();
                filterPanel.hide("slide", { direction: "left" }, 250, function () {
                    btnShowFilterPane.removeClass("IsSelected");
                    if (IsDefined(typeof (CS.docHtml))) {
                        CS.docHtml.trigger('panelclosed', filterPanel[0].id);
                    }
                });
            }
        }
        function HidePreSchedulesPanel() {
            if (preSchedulesPanel.is(":visible")) {
                preSchedulesPanel.hide("slide", { direction: "left" }, 250, function () {
                    btnPreSchedules.removeClass("IsSelected");
                    if (IsDefined(typeof (CS.docHtml))) {
                        CS.docHtml.trigger('panelclosed', preSchedulesPanel[0].id);
                    }
                });
            }
        }
        function ExtractDaysOfWeekFilter() {
            var ids = "";
            $('.DayOfWeekFilterRow input').each(function (i, element) {
                if (element.id != 'DayOfWeek_All') {
                    if (this.checked) {
                        ids += this.id.replace("DayOfWeek_", "") + ",";
                    }
                }
            });
            return ids;
        }
        function ExtractEncounterStatesFilter() {
            var ids = "";
            $('.EncounterStateRowFilter input').each(function (i, element) {
                if (element.id != 'Encounter_All') {
                    if (this.checked) {
                        ids += this.id.replace("EncounterState_", "") + ",";
                    }
                }
            });
            return ids;
        }
        function ExtractPreScheduleGroupAttemptFilter() {
            var dropDown = $('#PreScheduleGroupAttemptFilter select');
            return dropDown.val();
        }
        function ExtractLinkModesFilter() {
            var dropDown = $('#LinkModes');
            return dropDown.val();
        }
        function ExtractSurfacesFilter() {
            var ids = "";
            $('.SurfaceFilterRow input').each(function (i, element) {
                if (element.id != 'Surface_All') {
                    if (this.checked) {
                        ids += this.id.replace("Surface_", "") + ",";
                    }
                }
            });
            return ids;
        }
        function ExtractDivisionsFilter() {
            var ids = "";
            $('.DivisionFilterRow input').each(function (i, element) {
                if (element.id != 'Division_All') {
                    if (this.checked) {
                        ids += this.id.replace("Division_", "") + ",";
                    }
                }
            });
            return ids;
        }
        function ExtractValuesDisplayedFilter() {
            var ids = "";
            $('.ValuesDisplayedFilterRow input').each(function (i, element) {
                if (element.id != 'Value_All') {
                    if (this.checked) {
                        ids += this.id.replace("Value_", "") + ",";
                    }
                }
            });
            return ids;
        }
        function ExtractFilterMessageCount(response) {
            if (response.length > 1) {
                var filterMessageCount = $(response[1]);
                filteredSchedulesCount.off('click');
                if (filterMessageCount.data('mode') == 'SeeSchedulesMode') {
                    $('.FromToDiv').hide();
                    $('#BtnShowFilterPane').hide();
                    filteredSchedulesCount.on('click', function () {
                        window.location.reload();
                        //$('.FromToDiv').show();
                        //$('#BtnShowFilterPane').show();
                        //var updateFilter = $('#updateFilter');
                        //updateFilter.val('false');
                        //RefreshSchedules();
                    });
                }
                var html = filterMessageCount[0].innerHTML;
                if (filteredSchedulesCount.length > 0) {
                    filteredSchedulesCount[0].innerHTML = html;
                }
                filterMessageCount.remove();
            }
            //mettre a jour les datetimepicker.
            if (response.length > 2) {
                var startenddate = $(response[2]);
                var start = CS.Calendar.ParseISODate(startenddate.data('startdate'));
                var end = CS.Calendar.ParseISODate(startenddate.data('enddate'));
                document.StartDate.InputBox.datepicker('setDate', start);
                document.EndDate.InputBox.datepicker('setDate', end);
            }
            if (response.length > 3) {
                var warning = $(response[3]);
                if (warningFilterOutOfActualdate.length > 0) {
                    warningFilterOutOfActualdate[0].innerHTML = warning[0].innerHTML;
                }
            }
            else {
                if (warningFilterOutOfActualdate.length > 0) {
                    warningFilterOutOfActualdate[0].innerHTML = '';
                }
            }
        }
        //#endregion Filter pane
        CS.FormReady(function (formId) {
            if (formId == "Conflicts") {
                var checkAllConflict = $('#checkAllConflict');
                checkAllConflict.on('click', function (e) {
                    e.preventDefault();
                    checkAllConflict.val('true');
                    gridViewConflicts.RefreshGridData();
                    checkAllConflict.val('false');
                    checkAllConflictClicked = true;
                });
                $('#SelectedConflictType').controlIsLoaded(function (dropdown) {
                    dropdown.SelectionChange = function (e) {
                        checkAllConflict.val('false');
                        var advancedConflictsOptions = $('#AdvancedConflictsOptions');
                        if (dropdown.GetSelectedItemValue().value == "SelectedEncounter") {
                            advancedConflictsOptions.hide();
                        }
                        else {
                            advancedConflictsOptions.show();
                        }
                        gridViewConflicts.RefreshGridData();
                    };
                });
            }
            else if (formId == "EditSchedules") {
                $('#FlowBlockId').controlIsLoaded(function (dropdown) {
                    dropdown.SelectionChange = function (e) {
                        var data = { flowBlockId: dropdown.GetSelectedItemValue('value') };
                        CompuSport.Ajax.Get(CSParameters.RUrl + GetControllerName() + "/GetEntityTypeOfFb/" + CSParameters.SportEventId, data, function (response) {
                            $('#EntityType').val(response);
                        });
                    };
                });
                var $selectedSurfaceId;
                $('#SurfaceId').controlIsLoaded(function (dropdown) {
                    $selectedSurfaceId = dropdown;
                });
                $('#PlaceId').controlIsLoaded(function (dropdown) {
                    dropdown.SelectionChange = function (e) {
                        var PlaceIdValue = dropdown.GetValue(dropdown.$SelectedItem, 'value');
                        console.log('Changed PlaceId=' + PlaceIdValue);
                        if (PlaceIdValue == null) {
                            $selectedSurfaceId.SetValue(null);
                        }
                    };
                });
            }
            else if (formId == "CallMatchByTableForm") {
                $(document).offon('click.callnext', '#BtnCallNextMatch', function (e) {
                    e.preventDefault();
                    var selectedSurface = $('#selectedSurface').control().GetSelectedItemValue("value");
                    if (!selectedSurface) {
                        CompuSport.Controls.Popup.ShowWarningDialog(JSRess.PleaseSelectASurface);
                        return;
                    }
                    var data = {
                        selectedSurface: selectedSurface
                    };
                    CompuSport.Ajax.Post(CSParameters.RUrl + GetControllerName() + '/ExecCallMatchByTable/' + CSParameters.SportEventId, data, function (response) {
                        if (response.success) {
                            RefreshSchedules();
                            if (typeof popup !== 'undefined' && popup.Close) {
                                popup.Close();
                            }
                        }
                        else {
                            CompuSport.Controls.Popup.ShowWarningDialog(response.message);
                        }
                    }, function (error) {
                        try {
                            var errorResponse = JSON.parse(error.responseText);
                            CompuSport.Controls.Popup.ShowWarningDialog(errorResponse.message || "An error occurred");
                        }
                        catch (e) {
                            CompuSport.Controls.Popup.ShowWarningDialog(JSRess.NoMatchesFoundForTable);
                        }
                    });
                });
            }
            else if (formId == "offsetSchedule") {
                $('.CSDropDownCheckboxes').CSDropDownCheckboxes();
            }
        });
    })(desktop = Schedules.desktop || (Schedules.desktop = {}));
})(Schedules || (Schedules = {}));

//# sourceMappingURL=Schedules.desktop.js.map
